export const TESTIMONIALS = [
  {
    quote:
      "Really happy with the external wall insulation on my house. The whole experience was efficient and professional — everything ran smoothly from start to finish, all the workmen were polite and helpful. I have no hesitation in recommending this team.",
    name: "B. Wilkes",
    role: "Homeowner, Wirral",
  },
  {
    quote:
      "The crew managed our two-storey extension brilliantly. They communicated daily, kept the site spotless and finished a week ahead of schedule. Genuinely the best builders we’ve worked with.",
    name: "S. Hargreaves",
    role: "Homeowner, Liverpool",
  },
  {
    quote:
      "We commissioned a full refurbishment of our retail unit and they delivered it overnight in two phases so we never closed. Clean, sharp, on-budget — exactly what we needed.",
    name: "A. Patel",
    role: "Director, North West Retail Co.",
  },
  {
    quote:
      "Driveway, patio and garden walls — top job. Skilled trades and clear pricing. The Cresttor lads obviously take real pride in the finish.",
    name: "M. Rowlands",
    role: "Homeowner, Chester",
  },
];

export const COMPANY = {
  name: "Cresttor Construction Ltd",
  tagline: "Building with Integrity & Expertise",
  phone: "07729 565978",
  phoneHref: "tel:+447729565978",
  whatsappHref: "https://wa.me/447729565978",
  email: "cresttorconstruction@yahoo.co.uk",
  emailHref: "mailto:cresttorconstruction@yahoo.co.uk",
  website: "www.cresttorconstruction.com",
  area: "Liverpool · North West · North Wales · Midlands",
  basedIn: "Liverpool, UK",
  hours: [
    { day: "Mon – Fri", time: "08:30 – 17:30" },
    { day: "Saturday",  time: "08:30 – 13:00" },
    { day: "Sunday",    time: "Closed" },
  ],
  social: {
    instagram: "https://www.instagram.com/",
    facebook:  "https://www.facebook.com/",
    threads:   "https://www.threads.net/",
  },
  logoLight: "https://customer-assets.emergentagent.com/job_cresttor-launch/artifacts/8uhul2jp_CC%20Logo.png",
  logoComposite: "https://customer-assets.emergentagent.com/job_c34cdea0-366c-4972-9dd8-69229320be6a/artifacts/situegyb_CC%20Logos%20in%20light%2C%20dark%20and%20mono.png",
  staffPortrait: "https://customer-assets.emergentagent.com/job_c34cdea0-366c-4972-9dd8-69229320be6a/artifacts/ay0uth79_Man%20in%20Cresttor%20C%20Outfit.png",
  brandedVan: "https://customer-assets.emergentagent.com/job_c34cdea0-366c-4972-9dd8-69229320be6a/artifacts/w2sbs6zj_CC%20logo%20on%20a%20van%2C%20letter%20head%20%26%20sign.png",
  brandKit: "https://customer-assets.emergentagent.com/job_c34cdea0-366c-4972-9dd8-69229320be6a/artifacts/28hy7a39_CC%20Logo%20on%20hat%2C%20clothing%20and%20as%20favicon.png",
};
